import { Paper, TableCell, TableRow } from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Loading,
  ModalDeleteConfirm,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import Title from "App/Component/ui/title/Title";
import {
  MOBILE_INPUT_PAKET_TELEKONSUL,
  STYLE_DEFAULT_MASTER,
} from "App/constants";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
    convertToValidPrice,
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { FreezeTable } from "components/organism";
import React, { useEffect, useState } from "react";
import FormFilterPaketTelekonsul from "./FormFilterPaketTelekonsul";
import {
  deleteById,
  getByFilterPaket,
  headCells,
  RenderStatusPaket,
  RESET_STATE_FORM_FILTER,
  statusAktif,
  statusNonAktif,
} from "./helpers";

function DaftarPaketTelekonsul({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paketID, setPaketID] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterPaket(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickDelete = (row) => {
    setPaketID(row?.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deleteById(paketID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeMenu(MOBILE_INPUT_PAKET_TELEKONSUL);
      })
      .then(() => {
        changeParentData({
          id: row?.id,
          code: row?.code,
          nama: row?.nama,
          diskon: formatRupiah(row?.diskon),
          total_diskon: convertToValidPrice(row?.total_diskon),
          total_diskon2: formatRupiah(row?.total_diskon),
          tax: formatRupiah(row?.tax),
          total_tax: convertToValidPrice(row?.total_tax),
          total_tax2: formatRupiah(row?.total_tax),
          tanggal_start: isNull(row?.tanggal_start)
            ? ""
            : defaultDateInputDisplay(row?.tanggal_start),
          tanggal_expired: isNull(row?.tanggal_expired)
            ? ""
            : defaultDateInputDisplay(row?.tanggal_expired),
          biaya_lain: convertToValidPrice(row?.biaya_lain),
          biaya_lain2: formatRupiah(row?.biaya_lain),
          status_nama:row?.status === statusAktif ? "Aktif" : row?.status === statusNonAktif ? "Non-Akitf" : "Pilih Status",
          status: row?.status,
          remark: row?.remark,
          detail: [],
        });
        changeTitle(MOBILE_INPUT_PAKET_TELEKONSUL);
        handleClickMenu({
          code: MOBILE_INPUT_PAKET_TELEKONSUL,
          name: "Input Paket Telekonsul",
        });
      });
  };

  return (
    <>
      <div className={classes.root}>
      <Title title={"Daftar Paket Telekonsul"} />
        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}
        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <FormFilterPaketTelekonsul
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <TableDaftarRequest
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

export default DaftarPaketTelekonsul;

export const TableDaftarRequest = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  onlySelect = false,
  handleClickSelect,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const RenderAction = ({ row }) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "7px",
        }}
      >
        <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
          <PencilIcon />
        </IconButtonDatatable>
        <IconButtonDatatable onClick={() => handleClickDelete(row)}>
          <TrashIcon />
        </IconButtonDatatable>
      </div>
    );
  };

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={index}
            // style={{
            //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
            // }}
          >
            <TableCell scope="row" padding="none" align="center">
              {index + 1}
            </TableCell>

            <TableCell scope="row" padding="none" align="center">
              <RenderAction row={row} />
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">{row?.nama}</TableCell>
            <TableCell align="left">{row?.code}</TableCell>
            <TableCell align="left">
              <RenderStatusPaket status={row.status} />
            </TableCell>
            <TableCell align="left">
              {isNull(row?.diskon) ? 0 : row?.diskon} %
            </TableCell>
            <TableCell align="left">{formatNumber(row.total_diskon)}</TableCell>
            <TableCell align="left">
              {isNull(row?.tax) ? 0 : row?.tax} %
            </TableCell>
            <TableCell align="left">{formatNumber(row.total_tax)}</TableCell>
            <TableCell align="left">{formatNumber(row.biaya_lain)}</TableCell>
            <TableCell align="left">
              {isNull(row?.tanggal_start)
                ? "-"
                : defaultDateDisplay(row?.tanggal_start)}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.tanggal_expired)
                ? "-"
                : defaultDateDisplay(row?.tanggal_expired)}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.remark) ? null : row?.remark}
            </TableCell>

            <TableCell align="left">
              {defaultDateDisplay(row?.createdAt)}
            </TableCell>
            <TableCell align="left">{row?.createdBy}</TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.updatedAt)}
            </TableCell>
            <TableCell align="left">{row?.updatedBy}</TableCell>
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
